(function () {
  function qs(root, sel) { return root.querySelector(sel); }

  function safeJsonParse(txt) {
    try { return JSON.parse(txt || '{}'); } catch (e) { return {}; }
  }

  function formatMoneyFromCents(cents) {
    if (cents == null) return '';
    var n = Number(cents) / 100;
    var ccy = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'GBP';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: ccy }).format(n);
    } catch (e) {
      return '£' + n.toFixed(2);
    }
  }

  function percentOff(fullCents, gradedCents) {
    var a = Number(fullCents || 0);
    var b = Number(gradedCents || 0);
    if (!a || !b || b >= a) return '';
    return Math.round(((a - b) / a) * 100) + '%';
  }

  async function addToCart(variantId, qty) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    });
    if (!res.ok) throw new Error('Add failed');
    return res.json();
  }

  function init(root) {
    var form = qs(root, 'form.pw-product-form');
    if (!form) return;

    var modal = qs(root, '[data-pw-returns-modal]');
    if (!modal) return;

    var cfgEl = qs(root, '[data-pw-returns-config]');
    var skuMapEl = qs(root, '[data-pw-variant-sku-map]');
    if (!cfgEl || !skuMapEl) return;

    var cfg = safeJsonParse(cfgEl.textContent);
    var skuMap = safeJsonParse(skuMapEl.textContent);

    var gradeAHandle = cfg.gradeAHandle || '';
    var gradeBHandle = cfg.gradeBHandle || '';
    var currentHandle = cfg.currentHandle || '';

    var btnNew = qs(root, '[data-pw-returns-new]');
    var btnGraded = qs(root, '[data-pw-returns-graded]');
    if (!btnNew || !btnGraded) return;

    var offersWrap = qs(root, '[data-pw-offers-wrap]');

    var bypass = false;         // allow native submit when needed
    var offersCache = [];       // last computed offers for footer button

    function openModal() {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-pw-returns-close]')) closeModal();
    });

    function getSelectedVariantId() {
      var idInput = qs(form, 'input[name="id"]');
      return idInput ? String(idInput.value || '') : '';
    }

    function getSelectedSku() {
      var id = getSelectedVariantId();
      var sku = id ? (skuMap[id] || '') : '';
      return String(sku || '').trim();
    }

    function dismissKey(baseSku) { return 'pw_return_offer_dismissed_' + baseSku; }

    async function fetchProductJson(handle) {
      if (!handle) return null;
      var res = await fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return null;
      return await res.json();
    }

    function findVariantBySku(productJson, sku) {
      if (!productJson || !productJson.variants || !sku) return null;
      return productJson.variants.find(function (v) {
        return String(v.sku || '').trim() === sku && v.available;
      }) || null;
    }

    // Cache current product JSON (for full price)
    var currentProductPromise = null;
    function getCurrentProductJson() {
      if (!currentHandle) return Promise.resolve(null);
      if (!currentProductPromise) currentProductPromise = fetchProductJson(currentHandle);
      return currentProductPromise;
    }

    async function getFullPriceCents() {
      var selectedId = getSelectedVariantId();
      var currentJson = await getCurrentProductJson();
      if (!currentJson || !currentJson.variants) return 0;
      var n = Number(selectedId);
      var v = currentJson.variants.find(function (x) { return Number(x.id) === n; }) || null;
      return v ? Number(v.price || 0) : 0;
    }

    // Build offers array: A then B if available
    async function checkOfferAll() {
      var baseSku = getSelectedSku();
      if (!baseSku) return [];

      if (sessionStorage.getItem(dismissKey(baseSku)) === '1') return [];

      var skuA = baseSku + '-RA';
      var skuB = baseSku + '-RB';

      var results = await Promise.all([
        gradeAHandle ? fetchProductJson(gradeAHandle) : Promise.resolve(null),
        gradeBHandle ? fetchProductJson(gradeBHandle) : Promise.resolve(null)
      ]);

      var pA = results[0];
      var pB = results[1];

      var vA = pA ? findVariantBySku(pA, skuA) : null;
      var vB = pB ? findVariantBySku(pB, skuB) : null;

      var offers = [];

      if (vA) {
        offers.push({
          grade: 'A',
          label: 'Light',
          variantId: vA.id,
          qty: (typeof vA.inventory_quantity === 'number') ? vA.inventory_quantity : 1,
          price: Number(vA.price || 0),
          compare_at: Number(vA.compare_at_price || 0)
        });
      }

      if (vB) {
        offers.push({
          grade: 'B',
          label: 'Moderate',
          variantId: vB.id,
          qty: (typeof vB.inventory_quantity === 'number') ? vB.inventory_quantity : 1,
          price: Number(vB.price || 0),
          compare_at: Number(vB.compare_at_price || 0)
        });
      }

      return offers;
    }

    function setOfferCard(grade, offer, fullPriceCents) {
      if (!offersWrap) return;

      var card = offersWrap.querySelector('[data-pw-offer-card="' + grade + '"]');
      if (!card) return;

      if (!offer) {
        card.hidden = true;
        return;
      }

      card.hidden = false;

      var stockEl = offersWrap.querySelector('[data-pw-offer-stock="' + grade + '"]');
      var compareEl = offersWrap.querySelector('[data-pw-offer-compare="' + grade + '"]');
      var gradedEl = offersWrap.querySelector('[data-pw-offer-graded="' + grade + '"]');
      var saveEl = offersWrap.querySelector('[data-pw-offer-save="' + grade + '"]');
      var addBtn = offersWrap.querySelector('[data-pw-offer-add="' + grade + '"]');

      if (stockEl) stockEl.textContent = 'Only ' + (offer.qty || 1) + ' available';

      var compareCents = offer.compare_at && offer.compare_at > offer.price ? offer.compare_at : fullPriceCents;

      if (compareEl) compareEl.textContent = compareCents ? formatMoneyFromCents(compareCents) : '';
      if (gradedEl) gradedEl.textContent = offer.price ? formatMoneyFromCents(offer.price) : '';

      if (saveEl) {
        var pct = percentOff(compareCents, offer.price);
        saveEl.textContent = pct ? ('Save ' + pct) : '';
      }

      if (addBtn) {
        addBtn.onclick = async function () {
          addBtn.disabled = true;
          try {
            await addToCart(offer.variantId, 1);
            window.location.href = '/cart';
          } catch (e) {
            console.error(e);
            addBtn.disabled = false;
            alert("Sorry—couldn’t add to cart. Please try again.");
          }
        };
      }
    }

    function setOffersLayout(count) {
      if (!offersWrap) return;
      if (count >= 2) offersWrap.classList.add('pw-two-col');
      else offersWrap.classList.remove('pw-two-col');
    }

    function bestOffer(offers) {
      // Prefer A, else B
      var a = offers.find(function (o) { return o.grade === 'A'; });
      if (a) return a;
      var b = offers.find(function (o) { return o.grade === 'B'; });
      return b || null;
    }

    // MAIN: intercept ATC only if offers exist
    form.addEventListener('submit', async function (e) {
      if (bypass) return;
      if (!gradeAHandle && !gradeBHandle) return;

      e.preventDefault();

      try {
        var offers = await checkOfferAll();
        offersCache = offers || [];

        if (!offersCache.length) {
          // no offers => submit normally (native)
          bypass = true;
          form.submit();
          bypass = false;
          return;
        }

        var fullPriceCents = await getFullPriceCents();

        var byA = offersCache.find(function (o) { return o.grade === 'A'; }) || null;
        var byB = offersCache.find(function (o) { return o.grade === 'B'; }) || null;

        setOfferCard('A', byA, fullPriceCents);
        setOfferCard('B', byB, fullPriceCents);

        setOffersLayout((byA ? 1 : 0) + (byB ? 1 : 0));

        openModal();
      } catch (err) {
        console.error('[PW returns] error', err);
        // if anything fails, submit normally
        bypass = true;
        form.submit();
        bypass = false;
      }
    }, true);

    // Footer: Continue with new => dismiss + submit normally
    btnNew.addEventListener('click', function () {
      var baseSku = getSelectedSku();
      if (baseSku) sessionStorage.setItem(dismissKey(baseSku), '1');

      closeModal();

      bypass = true;
      form.submit();
      bypass = false;
    });

    // Footer: Add graded and save => add best offer (A then B)
    btnGraded.addEventListener('click', async function () {
      try {
        var offer = bestOffer(offersCache || []);
        if (!offer) return;

        closeModal();
        await addToCart(offer.variantId, 1);
        window.location.href = '/cart';
      } catch (e) {
        console.error(e);
        alert("Sorry—couldn’t add to cart. Please try again.");
      }
    });
  }

  function boot() {
    document.querySelectorAll('.pw-prod-mock').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();